import {createContext, ReactNode, useContext} from "react";
import {FormData} from '@ndcvbk/mensenlinq-editor'



type FieldDataContextType = {
  fieldData: FormData
}
const FieldDataContext = createContext<FieldDataContextType | undefined>(undefined);


export const useFieldData = () => {
  const ctx = useContext(FieldDataContext);
  if (!ctx) throw new Error('useFieldData must be used inside FieldDataProvider');
  return ctx.fieldData;
};

export function FieldDataProvider({ children, fieldData }: { children: ReactNode, fieldData: FormData}) {

  return <FieldDataContext.Provider value={{ fieldData }}>
    {children}
  </FieldDataContext.Provider>
}

export default useFieldData;